/**
 * KDDI's IOT トイ空室管理システムの URL の一部
 * 各場所のページ URL を生成するために必要
 * e.g. https://iot-toilet.kddi.com/u/okinawa/location/283/placement
 */
export const KDDI_IOT_TOILET_PLACE_URL = process.env.REACT_APP_KDDI_IOT_TOILET_PLACE_URL || ""

// Mappedin 関連設定
export const MAPPEDIN_CLIENT_ID = process.env.REACT_APP_MAPPEDIN_CLIENT_ID || ""
export const MAPPEDIN_SECRET = process.env.REACT_APP_MAPPEDIN_SECRET || ""
export const MAPPEDIN_LOCATION_NAME = process.env.REACT_APP_MAPPEDIN_LOCATION_NAME || ""
export const MAPPEDIN_SEARCH_KEY = process.env.REACT_APP_MAPPEDIN_SEARCH_KEY || ""
export const MAPPEDIN_SEARCH_SECRET = process.env.REACT_APP_MAPPEDIN_SEARCH_SECRET || ""

/**
 * 混雑状況確認カメラの iframe URL の一部
 * e.g. https://www.camera-lite.stg.ai.optim-test.com/embed/congestion
 */
export const CAMERA_LITE_URL = process.env.REACT_APP_CAMERA_LITE_URL || ""

/**
 * 強制的に Blue dot をデバッグ用に表示するかどうか
 */
export const DEBUG_ENABLE_BLUEDOT = process.env.REACT_APP_DEBUG_ENABLE_BLUEDOT === "true"

/**
 * Redux logger を有効化するかどうか
 */
export const ENABLE_REDUX_LOGGER = process.env.REACT_APP_ENABLE_REDUX_LOGGER === "true"
